import React, { FC, useEffect, useState } from "react";
import { Input, Button, Modal, Row, Col, Spin, Avatar, List, Checkbox, Badge, Dropdown, Radio } from "antd";
import _ from "lodash";

import { DeleteOutlined, HomeOutlined, LockOutlined, MessageOutlined, SettingOutlined, PhoneOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { getRole } from "utils/chatUtils";
import {
    wrapRequestPayload,
    getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";
import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import {
    getModifyPageSubscriptionTopic,
} from "hooks/MQTTConstants";
import { UserRoles } from "utils/appUtil";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { GET_FRIEND_PAGE } from "reducers/authReducer";



const AvatarItem: FC<{
    onPeopleMarkChange?: (user: any, e: any) => void,
    removeUser?: () => void,
    onChat?: () => void
    user: any,
    selectedItem?: SelectedSearchItem,
    index?: number
    isSelect?: boolean,
    isDelete?: boolean,
    isPermissionPopup?: boolean,
    isPrivateChat?: boolean,
    socket?: ISocket,
    onCloseParentModal?: () => void
}> = ({
    user,
    selectedItem,
    onPeopleMarkChange,
    index,
    isSelect,
    isDelete,
    isPermissionPopup,
    removeUser,
    socket,
    isPrivateChat,
    onChat,
    onCloseParentModal
}) => {
        const { adminRoles } = useSelector((state: RootState) => state.dashboard);
        const { friendSearchPage } = useSelector((state: RootState) => state.search);
        const { getLocalStorageItem } = useLocalStorageService();
        const dispatch = useDispatch();
        const [isModalVisible, setIsModalVisible] = useState(false);
        const [pendingAudioVideoAction, setPendingAudioVideoAction] = useState<'audio' | 'video' | null>(null);
        
        const sendPageUpdateEvent = (type, attributes) => {
            const modifyPagePayload: IMessage = getMessageRequestPayload(
                getLocalStorageItem(CID),
                getLocalStorageItem(RID),
                selectedItem.pageId,
                "",
                type,
                attributes
            );
            socket.publishToEvent(
                SocketTopics.PublishPageTopics,
                getModifyPageSubscriptionTopic(selectedItem.pageId),
                wrapRequestPayload(modifyPagePayload)
            );
        };
        let role = getRole(adminRoles, user);

        const handleModalClose = () => {
            setIsModalVisible(false);
            setPendingAudioVideoAction(null);
            if (onCloseParentModal) {
                onCloseParentModal();
            }
        };

        const handleChatClick = () => {
            dispatch(GET_FRIEND_PAGE({ friendUserId: user?.id }));
            handleModalClose();
        };

        const handleAudioVideoClick = (type: 'audio' | 'video') => {
            setPendingAudioVideoAction(type);
            dispatch(GET_FRIEND_PAGE({ friendUserId: user?.id }));
        };

        useEffect(()=>{
            console.log('user', user);
        }, [user])

        useEffect(() => {
            if (pendingAudioVideoAction && friendSearchPage && friendSearchPage.friendUserId === user?.id && friendSearchPage.pages && friendSearchPage.pages.length > 0) {
                const friendPageId = friendSearchPage.pages[0].pageId;
                const userId = getLocalStorageItem(RID);
                const orgId = getLocalStorageItem("selectedOrg") || "cudb-live";
                const url = `https://page.beam.live/?pageId=${friendPageId}&u=${userId}&o=${orgId}&metadata=${userId}`;
                window.open(url, '_blank');
                setPendingAudioVideoAction(null);
                handleModalClose();
            }
        }, [friendSearchPage, pendingAudioVideoAction, user?.id, getLocalStorageItem])

        const maskEmail = (email: string): string => {
            if (!email || !email.includes('@')) return email || '-';
            const [localPart, domain] = email.split('@');
            if (localPart.length <= 4) {
                return '*'.repeat(localPart.length) + '@' + domain;
            }
            const lastFour = localPart.slice(-4);
            const masked = '*'.repeat(localPart.length - 4);
            return masked + lastFour + '@' + domain;
        };

        const maskPhone = (phone: string): string => {
            if (!phone) return '-';
            const digitsOnly = phone.replace(/\D/g, '');
            if (digitsOnly.length <= 4) {
                return '*'.repeat(Math.max(phone.length, 4));
            }
            // Replace digits with * except last 4, preserving non-digit characters
            let result = '';
            let digitCount = 0;
            for (let i = 0; i < phone.length; i++) {
                if (/\d/.test(phone[i])) {
                    if (digitCount >= digitsOnly.length - 4) {
                        result += phone[i];
                    } else {
                        result += '*';
                    }
                    digitCount++;
                } else {
                    result += phone[i];
                }
            }
            return result;
        };

        const handleImageClick = () => {
            setIsModalVisible(true);
        };
        const rightsMenu = (user) => {
            return (
                <div className="menu-container rights-menu ml-auto people-dropdown p-0">
                    <div className="menu-item">
                        <Radio.Group
                            defaultValue={user?.role || UserRoles.Write}
                            onChange={(event) => {
                                sendPageUpdateEvent("updatePageMemberRole", {
                                    userId: user?.id,
                                    role: event.target.value,
                                });
                            }}
                        >
                            {[UserRoles.Edit, UserRoles.Read, UserRoles.Write].map((item) => (
                                <Radio.Button value={item} key={item}>
                                    {item.toUpperCase()}
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </div>
                </div>
            );
        };
        return (
            <React.Fragment>
                <Row style={{ clear: "both" }} className="person-item" key={index}>
                    <Col span={5}>
                        <img
                            src={
                                user?.profileImage?.urls?.original?.url ??
                                `/images/users/user.png`
                            }
                            width="45"
                            height="45"
                            onClick={handleImageClick}
                            style={{ cursor: 'pointer' }}
                        />
                    </Col>
                    <Col span={12}>
                        <h5>
                            {user && user.beamId
                                ? user.beamId
                                : user?.beamId && user?.beamId !== ""
                                    ? user?.beamId
                                    : `user #${user.id}`}
                        </h5>
                        {role && (<Badge count={
                            <div className="custom-badge text-white pl-2 pr-2 bg-green">
                                <span><SettingOutlined /></span>
                                <span className="ml-1" style={{ verticalAlign: "middle" }}>{role}</span></div>
                        } />)}
                        {user?.department && (<Badge className="ml-1" count={
                            <div className="custom-badge text-white pl-2 pr-2 bg-orange">
                                <span><HomeOutlined /></span>
                                <span className="ml-1" style={{ verticalAlign: "middle" }}>{user?.department}</span></div>
                        } />)}
                    </Col>
                    <Col span={7} className="t-right">
                        {isPrivateChat && (
                            <Button
                                className="beam-btn green-btn"
                                onClick={() => onChat()}
                            >
                                <MessageOutlined />
                            </Button>
                        )}
                        {selectedItem &&
                            selectedItem.currentUserRole === "edit" && (
                                <React.Fragment>
                                    {isSelect && (<Checkbox checked={user?.marked} onChange={(e) => onPeopleMarkChange(user, e)} className="circular-checkbox">
                                        <span className="checkmark"></span>
                                    </Checkbox>)}
                                    {isDelete && (<Button
                                        className="beam-btn mr-1 button orange-btn no-shadow cover"
                                        onClick={() => removeUser()}
                                    >
                                        <DeleteOutlined className="text-white" />
                                    </Button>)}
                                    {isPermissionPopup && (<Dropdown
                                        trigger={["click"]}
                                        overlay={rightsMenu(user)}
                                        className="message-dropdown"
                                        placement="bottomRight"
                                    >
                                        <a
                                            className="ant-dropdown-link"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <Button
                                                className="beam-btn no-shadow">
                                                <LockOutlined />
                                            </Button>

                                        </a>
                                    </Dropdown>)}
                                </React.Fragment>
                            )}
                    </Col>
                </Row>
                <Modal
                title="User Information"
                visible={isModalVisible}
                onCancel={handleModalClose}
                onOk={handleModalClose}
                width="480px"
                className="beam-modal"
                footer={[
                    <Button
                        key="close"
                        className="beam-btn orange-btn bordered w-full"
                        onClick={handleModalClose}
                    >
                        Close
                    </Button>
                ]}
                destroyOnClose={true}
            >
                <Row className="d-flex flex-column align-items-center mb-4">
                    <Col span={24} className="text-center mb-4">
                        <img
                            src={
                                user?.profileImage?.urls?.original?.url ??
                                `/images/users/user.png`
                            }
                            width="120"
                            height="120"
                            style={{ borderRadius: '50%', objectFit: 'cover' }}
                        />
                    </Col>
                </Row>
                
                <Row className="mb-3">
                    <Col span={24}>
                        <Row>
                            <Col span={8}><strong>First Name:</strong></Col>
                            <Col span={16}>{user?.firstName || '-'}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col span={24}>
                        <Row>
                            <Col span={8}><strong>Last Name:</strong></Col>
                            <Col span={16}>{user?.lastName || '-'}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col span={24}>
                        <Row>
                            <Col span={8}><strong>Beam ID:</strong></Col>
                            <Col span={16}>{user?.beamId || '-'}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col span={24}>
                        <Row>
                            <Col span={8}><strong>Email:</strong></Col>
                            <Col span={16}>{maskEmail(user?.email)}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col span={24}>
                        <Row>
                            <Col span={8}><strong>Phone:</strong></Col>
                            <Col span={16}>{maskPhone(user?.phone)}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col span={24}>
                        <Row>
                            <Col span={8}><strong>Role:</strong></Col>
                            <Col span={16}>{role || user?.role || '-'}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col span={24}>
                        <Row>
                            <Col span={8}><strong>Department:</strong></Col>
                            <Col span={16}>{user?.department || '-'}</Col>
                        </Row>
                    </Col>
                </Row>


                <Row className="mt-4">
                    <Col span={24} className="text-center">
                        <Button
                            className="beam-btn green-btn mr-2"
                            onClick={handleChatClick}
                            icon={<MessageOutlined />}
                        >
                            Chat
                        </Button>
                        <Button
                            className="beam-btn mr-2"
                            onClick={() => handleAudioVideoClick('audio')}
                            icon={<PhoneOutlined />}
                        >
                            Audio
                        </Button>
                        <Button
                            className="beam-btn"
                            onClick={() => handleAudioVideoClick('video')}
                            icon={<VideoCameraOutlined />}
                        >
                            Video
                        </Button>
                    </Col>
                </Row>

            </Modal>
            </React.Fragment>
        );
    };

export default AvatarItem;
